<template>

  <div class="pdf_main">

    <div class="function_intro">
        PDF导出功能介绍
      </div>

    <div class="text_intro">
        净信背单词支持list、生词本、熟知词、学习进度等pdf文件导出。
    </div>

    <div class="first_title">
      多种导出模式，满足不同需求
    </div>

    <div>
      <van-swipe :autoplay="3000" loop>
        <van-swipe-item v-for="(image,index) in images" :key="index" class="swipe-item">
          <div class="image-container">
            
            <div class="image-description">{{ image.description }}</div>
            <img :src="image.src" class="swipe-image" />
          
          </div>
        </van-swipe-item>
      </van-swipe>

    </div>

    <div class="first_title">
      多种导出参数，自主定制PDF
    </div>
    <div>
      <div>
        <div class="text_intro">
          1.自定义导出颜色主题
        </div>
        <div class="text_intro">
          2.自定义音标、释义显示
        </div>
        <div class="text_intro">
          3.自定义单列、双列显示
        </div>
        <div class="text_intro">
          4.自定义是否过滤熟知
        </div>
        
      </div>
    </div>

    <div  class="image-wrapper">
      <img :src="require('@/assets/pdfparm.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>


    <div class="first_title">
      满足多种导出需求
    </div>


    <div>
      <div>
        <div class="text_intro">
          1.整本词书导出：点击学习计划表右上角导出按钮，可导出整本书。
        </div>
        <div class="text_intro">
          2.单个list导出：主页中打开需要导出的list,点击菜单中导出pdf按钮，可导出单个list。
        </div>
        <div class="text_intro">
          3.生词本导出：打开单词本中的生词本，点击菜单中导出pdf按钮，可导出生词本。
        </div>
        <div class="text_intro">
          4.学习进度导出：打开单词本中的学习进度，可点击菜单中的导出pdf按钮，可按需导出。
        </div>
        
      </div>
      

      <div  class="image-wrapper">
      <img :src="require('@/assets/export_pdf.jpg')" style="width:90%; margin-top: 0.2rem;" />
    </div>


    </div>

    
  </div>

  

  
 



  
  

  
    
  </template>
  
  <script>
  export default {
    name: 'HomePage',
  
    setup() {
      const images = [
      { src: require('@/assets/1.jpg'), description: '单词默写', isChoosen: true },
      { src: require('@/assets/2.jpg'), description: '释义默写' },
      { src: require('@/assets/3.jpg'), description: '艾宾浩斯' },
      { src: require('@/assets/4.jpg'), description: '中英词表' }
      ];
      
      return { images };
    },
  
    methods: {
      // 在这里添加你的方法
    }
  };
  </script>
  
  <style scoped>

  .pdf_main {
    font-size: 0.4rem;
    margin-left: 0.4rem;
    margin-right: 0.4rem;
    text-align: left;
  }

  

  .text_intro {
    
    color: #000000;
    margin-top: 0.2rem;
    text-align: left;
    
    
    
  }

  .first_title {
    
    color: #000000;
    margin-top: 0.2rem;
    font-size: 0.5rem;
    text-align: left !important;
    display: inline-block; /* 使下划线长度适应文本 */
    border-bottom: 0.04rem solid blue; /* 使用 border-bottom 模拟下划线，并设置颜色为蓝色 */
    color: blue;
    margin-top: 0.5rem;
    font-weight: bold;
    
  }

  .swipe-item {
  display: flex;
  justify-content: center;
  align-items: center;
 
  width: auto; /* 根据图片宽度自动调整 */
}

.image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.swipe-image {
  height: 60vh; /* 设置高度为屏幕高度的一半 */
  object-fit: cover; /* 保持图片比例 */
}

.image-description {
  background-color: blue;
  color: white;
  margin-top: 0.3rem;  
  border-radius: 0.1rem;
  padding: 0.1rem 0.3rem;
  
}

.image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.function_intro{
    font-size: 0.6rem;
    margin-top: 0.5rem;
    margin-bottom: 0.3rem;
    color: blue;
    text-align: center;
    
  }
  
  </style>